import type { FC } from 'react';

export type ImpactTone =
  | 'high'
  | 'medium'
  | 'low'
  | 'critical'
  | 'warning'
  | 'good';

export interface StatusImpactPillProps {
  tone: ImpactTone;
  label: string;
}

const TONE_CLASS: Record<ImpactTone, string> = {
  high: 'om-impact-pill--critical',
  critical: 'om-impact-pill--critical',
  medium: 'om-impact-pill--warning',
  warning: 'om-impact-pill--warning',
  low: 'om-impact-pill--good',
  good: 'om-impact-pill--good',
};

export const StatusImpactPill: FC<StatusImpactPillProps> = ({
  tone,
  label,
}) => {
  return (
    <span className={`om-impact-pill ${TONE_CLASS[tone]}`}>
      <span className="om-impact-pill__dot" aria-hidden />
      {label}
    </span>
  );
};
